import { ArrowUpRight, ChevronDown, MapPin } from "lucide-react";
import { ui } from "@/content";

export default function ClinicCard({ clinic, showServices = false }) {
  const c = clinic;
  return (
    <article className="flex h-full flex-col rounded-[32px] bg-white p-6 ring-1 ring-line sm:p-9" data-testid={`clinic-card-${c.id}`} aria-labelledby={`clinic-${c.id}-title`}>
      <div className="flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-full bg-sage/55 text-forest"><MapPin className="h-5 w-5" aria-hidden="true" /></span>
        <p className="eyebrow">Mottagning</p>
      </div>
      <h3 id={`clinic-${c.id}-title`} className="mt-5 font-serif text-4xl text-ink">{c.city}</h3>
      <address className="mt-4 not-italic leading-relaxed text-ink/85" data-testid={`clinic-${c.id}-address`}>
        {c.addressLines.map((l) => <span key={l} className="block">{l}</span>)}
      </address>
      <ul className="mt-5 space-y-2 text-sm text-muted">
        {c.notes.map((n) => <li key={n} className="border-l-2 border-sage pl-3">{n}</li>)}
      </ul>
      {showServices && (
        <details className="group mt-6 rounded-2xl bg-cream p-4 sm:p-5" data-testid={`clinic-${c.id}-services`}>
          <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-semibold text-forest marker:hidden">
            <span>Tjänster och priser <span className="text-muted">({c.services.length})</span></span>
            <ChevronDown className="h-4 w-4 shrink-0 transition-transform group-open:rotate-180" aria-hidden="true" />
          </summary>
          <ul className="mt-4 max-h-[46vh] divide-y divide-line overflow-y-auto overscroll-contain pr-1 text-sm sm:max-h-[360px]">
            {c.services.map((s) => (
              <li key={s.name} className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-x-3 py-2.5 sm:gap-x-4">
                <span className="min-w-0 text-ink [overflow-wrap:anywhere]">{s.name}{s.note && <span className="block text-xs text-muted">{s.note}</span>}</span>
                <span className="whitespace-nowrap font-semibold text-ink">{s.price}</span>
              </li>
            ))}
          </ul>
        </details>
      )}
      <div className="mt-auto flex flex-col gap-3 pt-6 sm:flex-row sm:pt-8">
        <a href={c.bookingUrl} target="_blank" rel="noopener noreferrer" data-testid={`clinic-${c.id}-book-link`} className="np-btn inline-flex min-h-12 flex-none items-center justify-center gap-2 rounded-full bg-forest px-4 py-3 text-[15px] font-semibold text-cream hover:bg-pine sm:h-12 sm:flex-1 sm:px-6 sm:py-0">
          {ui.bookIn(c.city)} <ArrowUpRight className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span className="sr-only">({ui.opensBokadirekt})</span>
        </a>
        <a href={c.mapsUrl} target="_blank" rel="noopener noreferrer" data-testid={`clinic-${c.id}-map-link`} className="inline-flex min-h-12 shrink-0 items-center justify-center rounded-full px-5 py-3 text-[15px] font-semibold text-forest ring-1 ring-forest/25 hover:bg-sand sm:h-12 sm:py-0">
          {ui.showOnMap}
        </a>
      </div>
    </article>
  );
}
